function loadJS() {
  // eslint-disable-next-line

}
document.addEventListener('DOMContentLoaded', loadJS(), false)
